import TitleStripe from "../../common/TitleStripe";
import NoOcurrence from "../../common/query/NoOcurrence";
import PendenciasFinanceiras from "../../common/query/PendenciasFinanceiras";
import Protestos from "../../common/query/Protestos";
import ChequesSemFundos from "../../common/query/ChequesSemFundos";
import ParticipacaoEmEmpresas from "../../common/query/ParticipacaoEmEmpresas";
import {
  buildDurationLabel,
  countDadosCadastrais,
  countScore,
  formatDocument,
  formatToReal,
  getColorScore,
  getImageURLScoreSerasa,
  maskCEP,
} from "../../../utils/utils";
import { useState } from "react";
import { Modal } from "flowbite-react";
import StreetView from "../../common/query/StreetView";
import ModalReceitaFederal from "../../modals/ModalReceitaFederal";
import ScoreRating from "./ScoreRating";
import { FiUserCheck } from "react-icons/fi";
import { LuBuilding2 } from "react-icons/lu";
import moment from "moment";
import { HiOutlineCurrencyDollar, HiOutlineEye } from "react-icons/hi";
import { GrDocumentExcel, GrDocumentTime } from "react-icons/gr";
import HistoricoConsultas from "../../common/query/HistoricoConsultas";
import { EvaluationScorePJ } from "../../common/query/EvaluationScorePJ";
import { FaRegChartBar } from "react-icons/fa";
import { CiMoneyCheck1 } from "react-icons/ci";
import { EvaluationScore } from "../../common/query/EvaluationScore";

const SpcMaisQuery = ({ data, dataFull }) => {
  const [openMap, setOpenMap] = useState(false);

  const cadastro = data?.dadosCadastrais || {};
  const fullAddress = [
    cadastro.endereco,
    cadastro.numero,
    cadastro.bairro,
    cadastro.cidade,
    cadastro.cep,
  ]
    .filter(Boolean)
    .join(", ");
  const isPJ = Boolean(cadastro.cnpj);
  const foundationMoment =
    isPJ && cadastro.dataFundacao ? moment(cadastro.dataFundacao) : null;
  const foundationLabel =
    foundationMoment && foundationMoment.isValid()
      ? foundationMoment.format("DD/MM/YYYY")
      : null;
  const foundationAgeLabel = buildDurationLabel(
    foundationMoment,
    "de atividade"
  );

  const birthMoment =
    !isPJ && cadastro.dataNascimento ? moment(cadastro.dataNascimento) : null;
  const birthLabel =
    birthMoment && birthMoment.isValid()
      ? birthMoment.format("DD/MM/YYYY")
      : null;
  const birthYears =
    birthMoment && birthMoment.isValid()
      ? moment().diff(birthMoment, "years")
      : null;
  const birthAgeLabel =
    birthYears != null
      ? `${birthYears} ano${birthYears === 1 ? "" : "s"}`
      : null;

  return (
    <>
      <div>
        <TitleStripe>
          <div className="flex items-center gap-2">
            {data?.dadosCadastrais?.cpf ? (
              <FiUserCheck className="text-blue-700" />
            ) : (
              <LuBuilding2 className="text-blue-700" />
            )}

            <span>Dados Cadastrais / Base III</span>
          </div>
        </TitleStripe>

        <div className="mt-4 text-xs">
          <div className="flex flex-wrap items-start justify-between gap-3">
            <div>
              <p className="text-[10px] uppercase tracking-[0.2em] text-gray-400">
                {data?.dadosCadastrais?.cnpj ? "Razão Social" : "Nome COmpleto"}
              </p>
              <p className="text-lg font-semibold text-gray-900">
                {data?.dadosCadastrais?.cnpj
                  ? data?.dadosCadastrais?.razaoSocial || "Indisponível"
                  : data?.dadosCadastrais?.nome || "Indisponível"}
              </p>
              <p className="text-[11px] text-gray-500">
                {data?.dadosCadastrais?.cnpj
                  ? data?.dadosCadastrais?.nomeFantasia || "Sem nome fantasia"
                  : data?.dadosCadastrais?.cpf || "CPF não informado"}
              </p>
            </div>
            {data?.dadosCadastrais?.cnpj && (
              <ModalReceitaFederal cnpj={data?.dadosCadastrais?.cnpj} />
            )}
          </div>

          <div className="mt-2 flex flex-wrap gap-2 text-[10px] text-gray-500">
            <span className="inline-flex items-center rounded-full border border-gray-200 bg-slate-50 px-2 py-0.5">
              {data?.dadosCadastrais?.situacao || "Situação desconhecida"}
            </span>
            <span className="inline-flex items-center rounded-full border border-gray-200 bg-slate-50 px-2 py-0.5">
              {data?.dadosCadastrais?.cnpj
                ? `Fundação: ${foundationLabel || "—"}`
                : `Nascimento: ${birthLabel || "—"}`}
            </span>
            {data?.dadosCadastrais?.cnpj && foundationAgeLabel && (
              <span className="inline-flex items-center rounded-full border border-gray-200 bg-slate-50 px-2 py-0.5">
                {foundationAgeLabel}
              </span>
            )}
            {!data?.dadosCadastrais?.cnpj && birthAgeLabel && (
              <span className="inline-flex items-center rounded-full border border-gray-200 bg-slate-50 px-2 py-0.5">
                {birthAgeLabel}
              </span>
            )}
          </div>

          <div className="mt-3 grid gap-2 grid-cols-2">
            {(isPJ
              ? [
                  {
                    label: "CNPJ / MF",
                    value: data?.dadosCadastrais?.cnpj
                      ? formatDocument(data?.dadosCadastrais?.cnpj)
                      : "Não disponível",
                    hint: "Documento",
                  },
                  {
                    label: "CNAE",
                    value: data?.dadosCadastrais?.ramoAtividade || "—",
                    hint: "Atividade",
                  },
                  {
                    label: "Capital social",
                    value:
                      formatToReal(data?.dadosCadastrais?.capitalSocial) || "—",
                    hint: "Recursos",
                  },
                  {
                    label: "E-mail",
                    value: data?.dadosCadastrais?.email || "—",
                    hint: "E-mail do responsável",
                  },
                ]
              : [
                  {
                    label: "CPF",
                    value: formatDocument(data?.dadosCadastrais?.cpf),
                    hint: "Documento",
                  },
                  {
                    label: "Origem CPF",
                    value: data?.dadosCadastrais?.regiaoCPF || "—",
                    hint: "Região",
                  },
                  {
                    label: "Telefone",
                    value: data?.dadosCadastrais?.telefone || "—",
                    hint: "Telefone principal",
                  },

                  {
                    label: "E-mail",
                    value: data?.dadosCadastrais?.email || "—",
                    hint: "E-mail principal",
                  },
                ]
            ).map((item) => (
              <div
                key={item.label}
                className="rounded-xl border border-gray-100 bg-slate-50 px-3 py-2"
              >
                <p className="text-[10px] uppercase tracking-[0.2em] text-gray-400">
                  {item.label}
                </p>
                <p className="text-base font-semibold text-gray-900">
                  {item.value}
                </p>
                <p className="text-[10px] text-gray-500">{item.hint}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <TitleStripe className="mt-4">
        <div className="flex items-center gap-2 uppercase">
          <LuBuilding2 className="text-blue-700" /> <span>Localização</span>
        </div>
      </TitleStripe>

      <div className="mt-4 flex flex-col gap-2">
        <div className="grid gap-2 grid-cols-2">
          <div className="rounded-xl border border-gray-200 bg-white px-3 py-2">
            <p className="text-[10px] uppercase tracking-[0.2em] text-gray-400">
              Endereço
            </p>
            <p className="text-[12px] font-semibold text-gray-900">
              {data?.dadosCadastrais?.endereco || "—"}
            </p>
          </div>
          <div className="rounded-xl border border-gray-200 bg-white px-3 py-2">
            <p className="text-[10px] uppercase tracking-[0.2em] text-gray-400">
              Bairro · CEP
            </p>
            <p className="text-[12px] font-semibold text-gray-900 flex flex-wrap gap-1">
              <span>{data?.dadosCadastrais?.bairro || "—"}</span>
              <span>·</span>
              <span>{maskCEP(data?.dadosCadastrais?.cep) || "--"}</span>
            </p>
          </div>
        </div>

        <div className="grid gap-2 grid-cols-2">
          <div className="rounded-xl border border-gray-200 bg-white px-3 py-2">
            <p className="text-[10px] uppercase tracking-[0.2em] text-gray-400">
              Cidade
            </p>
            <p className="text-[12px] font-semibold text-gray-900">
              {data?.dadosCadastrais?.cidade || "—"}
            </p>
          </div>
          <div className="rounded-xl border border-gray-200 bg-white px-3 py-2">
            <p className="text-[10px] uppercase tracking-[0.2em] text-gray-400">
              UF
            </p>
            <p className="text-[12px] font-semibold text-gray-900">
              {data?.dadosCadastrais?.uf || "--"}
            </p>
          </div>
        </div>
      </div>

      <TitleStripe>
        <div className="flex items-center gap-2">
          <FaRegChartBar className="text-blue-700" />{" "}
          <span>Avaliação preliminar de crédito / Base III</span>
        </div>
      </TitleStripe>

      {isPJ ? (
        <>
          {data?.score?.score == 0 ? (
            <div className="p-4 bg-yellow-50 border border-yellow-200 rounded-lg text-yellow-800 text-sm mt-4">
              <p className="font-medium">
                Não foi possível calcular o score desta empresa.
              </p>
              <p className="mt-1">
                É necessário verificar as outras informações disponíveis no
                relatório para uma análise completa.
              </p>
            </div>
          ) : (
            <div className="mt-4">
              <EvaluationScorePJ
                data={data}
                score={data?.score?.score}
                probability={+data?.score?.probabilidade * 100}
                type="CNPJ"
                hasIncome={false}
              />
            </div>
          )}
        </>
      ) : (
        <>
          {data?.score?.score == 0 ? (
            <div className="p-4 bg-yellow-50 border border-yellow-200 rounded-lg text-yellow-800 text-sm mt-4">
              <p className="font-medium">
                Não foi possível calcular o score desta empresa.
              </p>
              <p className="mt-1">
                É necessário verificar as outras informações disponíveis no
                relatório para uma análise completa.
              </p>
            </div>
          ) : (
            <div className="mt-4">
              <EvaluationScore
                data={data}
                score={data?.score?.score}
                probability={+data?.score?.probabilidade * 100}
                hasIncome={false}
              />
            </div>
          )}
        </>
      )}

      <div>
        <TitleStripe className="mb-4">
          <div className="flex items-center gap-2">
            <HiOutlineCurrencyDollar className="text-blue-700" />
            <span>Restrições Financeiras / Base III</span>
          </div>
        </TitleStripe>

        {data?.pendenciasFinanceiras?.length > 0 ? (
          <div className="flex gap-2 items-start">
            <div className="flex-1">
              <PendenciasFinanceiras
                quantidadeTotal={
                  data?.resumoConsulta?.pendenciasFinanceiras?.quantidadeTotal
                }
                valorTotal={
                  data?.resumoConsulta?.pendenciasFinanceiras?.valorTotal
                }
                pendenciasFinanceiras={data?.pendenciasFinanceiras}
              />
            </div>
          </div>
        ) : (
          <NoOcurrence />
        )}
      </div>

      <div>
        <TitleStripe className="mb-4">
          <div className="flex items-center gap-2">
            <GrDocumentExcel className="text-blue-700" />
            <span>Títulos protestados / Base III</span>
          </div>
        </TitleStripe>

        {data?.protestos?.length > 0 ? (
          <div className="flex gap-2 items-start">
            <div className="flex-1">
              <Protestos
                quantidadeTotal={
                  data?.resumoConsulta?.protestos?.quantidadeTotal
                }
                valorTotal={data?.resumoConsulta?.protestos?.valorTotal}
                protestos={data?.protestos}
              />
            </div>
          </div>
        ) : (
          <NoOcurrence />
        )}
      </div>

      <div>
        <TitleStripe className="mb-5">
          <div className="flex items-center gap-2">
            <CiMoneyCheck1 className="text-blue-700" />
            <span>Cheques sem fundo / Base III</span>
          </div>
        </TitleStripe>

        {data?.chequesSemFundo?.length > 0 ? (
          <>
            <ChequesSemFundos
              quantidadeTotal={
                data?.resumoConsulta?.chequesSemFundo?.quantidadeTotal
              }
              chequesSemFundos={data?.chequesSemFundo}
            />
          </>
        ) : (
          <NoOcurrence />
        )}
      </div>

      <div>
        <TitleStripe className="mb-5">
          <div className="flex items-center gap-2">
            <GrDocumentTime className="text-blue-700" />
            <span>Histórico de consultas / Base III</span>
          </div>
        </TitleStripe>

        {data?.historicoConsultas?.length > 0 ? (
          <div className="flex flex-col gap-2">
            <div className="flex-1">
              <HistoricoConsultas
                quantidadeTotal={data?.historicoConsultas?.length}
                historicoConsultas={data?.historicoConsultas}
              />
            </div>
            {/* {data?.historicoConsultasResumo?.paresMesAnoHistoricoConsultas
              ?.length > 0 && (
              <ReactApexChart
                className="border border-gray-200 rounded-md mt-3"
                options={{
                  colors: ["var(--primary)"],
                  chart: {
                    height: 150,
                    type: "bar",
                    toolbar: {
                      show: false, // Remove o menu de ações
                    },
                  },
                  plotOptions: {
                    bar: {
                      borderRadius: 2,
                      dataLabels: {
                        position: "center", // top, center, bottom
                      },
                    },
                  },
                  dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                      return val;
                    },
                    offsetY: 0,
                    style: {
                      fontSize: "12px",
                      colors: ["white"],
                    },
                  },

                  xaxis: {
                    categories:
                      data?.historicoConsultasResumo
                        ?.paresMesAnoHistoricoConsultas,
                    position: "top",
                    axisBorder: {
                      show: false,
                    },
                    axisTicks: {
                      show: false,
                    },
                    crosshairs: {
                      fill: {
                        type: "gradient",
                        gradient: {
                          colorFrom: "#30ce2d",
                          colorTo: "#30ce2d",
                          stops: [0, 100],
                          opacityFrom: 0.4,
                          opacityTo: 0.5,
                        },
                      },
                    },
                    tooltip: {
                      enabled: true,
                    },
                  },
                  yaxis: {
                    axisBorder: {
                      show: false,
                    },
                    axisTicks: {
                      show: false,
                    },
                    labels: {
                      show: false,
                      formatter: function (val) {
                        return val;
                      },
                    },
                  },
                  title: {
                    text: "Últimos 12 meses",
                    floating: true,
                    offsetY: 200,
                    align: "center",
                    style: {
                      color: "#444",
                    },
                  },
                }}
                series={[
                  {
                    name: "Qtd. Consultas no período",
                    data: data?.historicoConsultasResumo
                      ?.totaisHistoricoConsultas,
                  },
                ]}
                type="bar"
                height={220}
              />
            )} */}
          </div>
        ) : (
          <NoOcurrence />
        )}
      </div>

      <Modal show={openMap} onClose={() => setOpenMap(false)} size="5xl">
        <Modal.Header>Localização</Modal.Header>
        <Modal.Body>
          <div className="space-y-2">
            <div className="text-sm text-gray-600">
              <strong>Endereço:</strong> {fullAddress || "—"}
            </div>
            {fullAddress ? (
              <StreetView address={fullAddress} height={460} />
            ) : (
              <div className="p-3 text-sm text-gray-500">
                Endereço indisponível.
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default SpcMaisQuery;
